import getConfig from 'next/config';
import { ButtonVariants } from '../../../Atoms/Button';
import { INDEX_SLUG_TYPE } from '../../index-page/types';
import { LIVE_PRICE, STOCK_SLUG_TYPE } from '../types';

const { publicRuntimeConfig } = getConfig();

const BSE_POLLING_INTERVAL_IN_MS = 60000;
const NSE_POLLING_INTERVAL_IN_MS = 300000;

export const getStatus = (
  isCompanyStock: boolean,
  stockDetails: STOCK_SLUG_TYPE | INDEX_SLUG_TYPE,
  exchange: string
): string => {
  if (isCompanyStock) {
    if (exchange === 'BSE') {
      return 'bse_status' in stockDetails ? stockDetails.bse_status : '';
    }
    return 'nse_status' in stockDetails ? stockDetails.nse_status : '';
  }
  return '';
};

export const fetchStockDailyPrice = (
  companyCode: number,
  interval: string,
  exchange: string
): Promise<number[][]> => {
  let apiURI;
  if (interval === '1Y' || interval === '3Y' || interval === '5Y') {
    apiURI = 'daily';
  } else {
    apiURI = 'minutely';
  }
  return fetch(
    `${publicRuntimeConfig.STOCKS_BACKEND_ENDPOINT}/price-graph/${apiURI}?co_code=${companyCode}&interval=${interval}&exchange=${exchange}`
  )
    .then((res) => res.json())
    .then((data) => data)
    .catch((err) => {
      console.log(err, 'price api failed'); // need to have better error handling and error boundaries
    });
};

export const fetchStockLivePrice = (
  companyCode: number,
  exchange: string
): Promise<LIVE_PRICE> => {
  return fetch(
    `${publicRuntimeConfig.STOCKS_BACKEND_ENDPOINT}/live-price?co_code=${companyCode}&exchange=${exchange}`
  )
    .then((res) => res.json())
    .then((data) => data)
    .catch((err) => {
      console.log(err, 'live price api failed'); // need to have better error handling and error boundaries
    });
};

export const isTimeValidToPollApi = (timestamp?: number): boolean => {
  // currently returns false for outside 8:30am - 4:30pm on weekdays and on weekends
  const currentDay = new Date().getDay();
  if (currentDay === 0 || currentDay === 6) {
    // 0->Sunday 6->Saturday
    return false;
  }
  if (timestamp) {
    const utcHourOfLatestTimeStamp = new Date(timestamp).getUTCHours();
    const utcMinOfLatestTimeStamp = new Date(timestamp).getUTCMinutes();
    if (utcHourOfLatestTimeStamp < 3 || utcHourOfLatestTimeStamp >= 10) {
      if (utcMinOfLatestTimeStamp >= 15)
        // between 8:30am and 4:15pm
        return false;
    }
  }
  return true;
};

export const getShowTimeStamp = (timestamp: string): boolean => {
  return timestamp === '1D' ||
    timestamp === '1W' ||
    timestamp === '1M' ||
    timestamp === '3M'
    ? true
    : false;
};

export const getButtonVariant = (CAGRpos: boolean | null): ButtonVariants => {
  if (CAGRpos === null) {
    return ButtonVariants.blue;
  }
  return CAGRpos ? ButtonVariants.green : ButtonVariants.red;
};

export const ChartPlaceholder = (
  loading: boolean,
  exchange: string,
  status: string
): JSX.Element => {
  let stockStatus = '';
  switch (status) {
    case 'Not Listed':
      stockStatus = 'This stock is currently not listed in';
      break;
    case 'Delisted':
      stockStatus = 'This stock has been delisted from';
      break;
    case 'Suspended':
      stockStatus = 'This stock is currently suspended from';
      break;
    default:
      stockStatus = 'No data to show from';
  }
  return (
    <div
      id={'chartPlaceHolderText'}
      className="w-full h-[400px] mt-[30px] text-center text-font-200 text-s-14 flex items-center justify-center"
    >
      {loading ? 'Loading...' : `${stockStatus} ${exchange}`}
    </div>
  );
};

export const getIntervalForPolling = (
  exchange: string,
  count: number,
  timestamp?: number | null
): null | number => {
  if (count === 5) return null;
  else if (timestamp && !isTimeValidToPollApi(timestamp)) return null;
  else
    return exchange === 'BSE'
      ? BSE_POLLING_INTERVAL_IN_MS
      : NSE_POLLING_INTERVAL_IN_MS;
};
